<!-- <h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
    <ng-container *ngIf="data.content">
        <ng-container *ngTemplateOutlet="data.content; context: { close: data.closeFn }"></ng-container>
    </ng-container>
</mat-dialog-content> -->

<div class="baoTitleCC">
  <h2 mat-dialog-title class="Title__popupCC">
    {{ "LOGIN.DOIMK" | translate }}
  </h2>

  <span class="span__pCC" mat-dialog-close>
    <i class="ti ti-x"></i>
  </span>
</div>

<mat-dialog-content>
  <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="full-width__CC">
          <digi-password
            class="email__customPass"
            [label]="'LOGIN.PLACEHOLDER.MKHIENTAI' | translate"
            [placeholder]="'LOGIN.PLACEHOLDER.MKHIENTAI' | translate"
            [control]="f.passwordOld"
            [isSubmit]="isSubmit"
            [errorMessage]="errOldPassword"
            (inputChanged)="checkOldPassword()"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="full-width__CC">
          <digi-password
            class="email__customPass"
            [label]="'LOGIN.PLACEHOLDER.MKMOI' | translate"
            [placeholder]="'LOGIN.PLACEHOLDER.MKMOI' | translate"
            [control]="f.passwordNew"
            [isSubmit]="isSubmit"
            [errorMessage]="errNewPassword"
            (inputChanged)="checkNewPassword()"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="full-width__CC">
          <digi-password
            class="email__customPass"
            [label]="'LOGIN.PLACEHOLDER.XACNHANMK' | translate"
            [placeholder]="'LOGIN.PLACEHOLDER.XACNHANMK' | translate"
            [control]="f.confirmPassword"
            [isSubmit]="isSubmit"
            [errorMessage]="errConfirmPassword"
            (inputChanged)="checkComparePassword()"
          />
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" class="btn-save" (click)="onSubmit()">
    <i class="ti ti-device-floppy" style="font-size: 16px"></i>
    <span>{{ "BRANCH.LUUTHONGTIN" | translate }}</span>
  </button>
</mat-dialog-actions>
